export enum ProductStatus {
  VERIFIED = "VERIFIED",
  NEED_TO_BE_VERIFIED = "NEED_TO_BE_VERIFIED",
  CHANGE_REQUESTED = "CHANGE_REQUESTED",
}

export const PRODUCT_STATUS_CONFIG = {
  [ProductStatus.VERIFIED]: {
    text: "Vérifié",
    backgroundColor: "green.100",
    color: "green.800",
  },
  [ProductStatus.NEED_TO_BE_VERIFIED]: {
    text: "À vérifier",
    backgroundColor: "orange.100",
    color: "orange.800",
  },
  [ProductStatus.CHANGE_REQUESTED]: {
    text: "Modification demandée",
    backgroundColor: "red.100",
    color: "red.800",
  },
} as const;

export const getProductStatusLabel = (status: ProductStatus): string => PRODUCT_STATUS_CONFIG[status].text;
